import { PRIMARY_BILLING_LABEL } from 'constant';

/**
 * Filter locations by user input
 *
 * @param {{locationId: string; label: string; serviceLocationName: string;}[]} locations
 * @param {string} inputValue
 * @returns {{locationId: string; label: string; serviceLocationName: string;}[]} locations found
 */
const filterLocations = (locations, { inputValue }) =>
  locations.filter(({ label }) =>
    label.toLowerCase().includes(inputValue.toLowerCase())
  );

/**
 * Parse location and site data to build the required structure for dropdown.
 *
 * @param {number} billToSiteNumber
 * @param {string} billToSiteName
 * @param {string} serviceLocationName
 * @returns {
 * {locationId: number, serviceLocationName: string, label: string, isOneLocation: boolean,
 * groupByBillSiteAndSiteName: string } } location parsed
 */
const parseLocationForDropdown = ({
  billToSiteNumber,
  billToSiteName,
  serviceLocationName,
  defaultBillingSite,
}) => {
  const locationLabel = serviceLocationName || billToSiteName;
  const primaryLabel = defaultBillingSite ? PRIMARY_BILLING_LABEL : '';

  return {
    label: `${locationLabel}${primaryLabel}`,
    locationId: billToSiteNumber,
    serviceLocationName: locationLabel,
    groupByBillSiteAndSiteName: `${billToSiteNumber} - ${billToSiteName}`,
    isOneLocation: !serviceLocationName,
  };
};

/**
 * Parse selectedLocation to be displayed in dropdown
 *
 * @param {{locationId: string; label: string; serviceLocationName: string;}} selectedLocation
 * @returns {string} service location name
 */
const parseSelectedLocation = selectedLocation =>
  selectedLocation.serviceLocationName;

export { filterLocations, parseLocationForDropdown, parseSelectedLocation };
